import React from "react";

import Div100vh from "react-div-100vh";

import { chatHelpMessage } from "@/lib/helper";
import CallIcon from "@/assets/icons/call-icon-ellipse.svg";
import ProfileIcon from "@/assets/icons/profile-icon.svg";
import TwoProfileIcon from "@/assets/icons/two-profile-icon.svg";
import WhatsappIcon from "@/assets/icons/whatsapp-icon.svg";
import InProgressIcon from "@/assets/icons/track_tenant/inprogress-icon.svg";
import PendingIcon from "@/assets/icons/track_tenant/pending-icon.svg";
import SuccessIcon from "@/assets/icons/track_tenant/success-icon.svg";

const STATUS_ICONS = {
  COMPLETED: <img src={SuccessIcon} />,
  PENDING: <img src={InProgressIcon} />,
  FAILED: <img src={PendingIcon} />,
};

const SAMPLE_DATA = [
  {
    name: "tenant-verification",
    state: "PENDING",
    status: "COMPLETED",
    remark: null,
    createdAt: "2024-11-07T06:20:40.463Z",
    completedAt: null,
    closedAt: null,
    closedBy: null,
    closerId: null,
    actor: "SYSTEM",
  },
  {
    name: "tenant-onboarding",
    state: "PENDING",
    status: "COMPLETED",
    remark: null,
    createdAt: "2024-11-07T06:20:40.463Z",
    completedAt: null,
    closedAt: null,
    closedBy: null,
    closerId: null,
    actor: "SYSTEM",
  },
  {
    name: "rent-agreement",
    state: "PENDING",
    status: "COMPLETED",
    remark: null,
    createdAt: "2024-11-07T06:20:40.463Z",
    completedAt: null,
    closedAt: null,
    closedBy: null,
    closerId: null,
    actor: "SYSTEM",
  },
  {
    name: "movein",
    state: "PENDING",
    status: "PENDING",
    remark: null,
    createdAt: "2024-11-07T06:20:40.463Z",
    completedAt: null,
    closedAt: null,
    closedBy: null,
    closerId: null,
    actor: "SYSTEM",
  },
  {
    name: "disbursal-initiated",
    state: "PENDING",
    status: "FAILED",
    remark: null,
    createdAt: "2024-11-07T06:20:40.463Z",
    completedAt: null,
    closedAt: null,
    closedBy: null,
    closerId: null,
    actor: "SYSTEM",
  },
  {
    name: "transaction-completed",
    state: "PENDING",
    status: "FAILED",
    remark: null,
    createdAt: "2024-11-07T06:20:40.463Z",
    completedAt: null,
    closedAt: null,
    closedBy: null,
    closerId: null,
    actor: "SYSTEM",
  },
];

const StepProgressBar = ({ steps }) => {
  const rows = [];
  for (let i = 0; i < steps.length; i += 3) {
    const row = steps.slice(i, i + 3);
    rows.push(i % 2 === 0 ? row : row.reverse());
  }

  return (
    <div className="step-progress-bar flex flex-col gap-8 px-8">
      {rows.map((row, rowIndex) => (
        <>
          <div
            key={rowIndex}
            className="row flex items-center gap-4 justify-between w-full"
          >
            {row.map((step, stepIndex) => (
              <React.Fragment key={step.name}>
                <div className="step flex flex-col items-center w-1/3">
                  <div className="icon">
                    {STATUS_ICONS[step.status] || STATUS_ICONS.PENDING}
                  </div>
                  <div className="name text-2xs font-thin text-center">
                    {step.name === "movein"
                      ? "MoveIn Status"
                      : step.name
                          .replace(/-/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </div>
                </div>
                {stepIndex < row.length - 1 && (
                  <div className="border-[.8px] border-dashed w-8 -mt-8" />
                )}
              </React.Fragment>
            ))}
          </div>
          {rowIndex === 0 && (
            <div className="vertical-line-row w-full flex justify-end -my-6">
              <div className="border-r-[1px] border-dashed h-12 mx-9" />
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default function TenantTrackingScreen() {
  return (
    <Div100vh className="flex flex-col py-8 gap-4 justify-between">
      <div className="flex justify-between items-center px-8">
        <span className="text-xs">FAQ's</span>
        <button onClick={() => chatHelpMessage()}>
          <img src={WhatsappIcon} alt="" className="max-w-8" />
        </button>
      </div>
      <div className="flex flex-col justify-between gap-8">
        <div className="flex flex-col justify-between gap-2">
          <div className="flex flex-col justify-between pr-8">
            <div className="bg-[#0031fb] text-white text-xl font-medium font-['Montserrat']">
              <span className="px-8">Advance Rent Unlocked</span>
            </div>
            <span className="text-white text-xl font-['Montserrat'] pl-8">
              You Are About To Receive
            </span>
          </div>
          <span className="text-white text-xs font-thin pl-8">
            Track Your Tenant Onboarding Progress
          </span>
        </div>
        <StepProgressBar steps={SAMPLE_DATA} />
      </div>
      <div className="flex justify-between items-center font-medium text-black gap-6 px-8">
        <button className="w-[153.80px] h-[53px] p-[18.71px] bg-[#eeeeee] border-2 border-[#979797] justify-center items-center gap-[10.39px] inline-flex">
          <div className="text-[#010101] text-[12.81px] font-medium font-['Montserrat'] leading-none">
            Move-In Report
          </div>
        </button>
        <button className="w-[153.80px] h-[53px] p-[18.71px] bg-[#eeeeee] border-2 border-[#979797] justify-center items-center gap-[10.39px] inline-flex">
          <div className="text-[#010101] text-[12.81px] font-medium font-['Montserrat'] leading-none">
            Rent Summary
          </div>
        </button>
      </div>
      <div className="flex flex-col justify-between items-center gap-4 px-8">
        <span>Tenant Details</span>
        <div className="border border-[#eeeeee]/30">
          <div className="flex justify-between items-center gap-12 p-6">
            <div className="flex justify-between items-center gap-4">
              <img src={ProfileIcon} alt="profile-icon" />
              <div className="flex flex-col text-[#999999] text-sm gap-2 font-medium">
                <span>Sameer Khan</span>
                <span>6239694090</span>
              </div>
            </div>
            <button>
              <img src={CallIcon} alt="call-icon" />
            </button>
          </div>
          <div className="flex justify-between items-center bg-[#313131]/95 px-6 py-4">
            <div className="flex items-center gap-2">
              <img src={TwoProfileIcon} alt="profile-icon" />
              <span className="text-[#bbbbbb] text-xs">+3</span>
            </div>
            <span className="text-[#bbbbbb] text-2xs">View All</span>
          </div>
        </div>
      </div>
    </Div100vh>
  );
}
